import { render, staticRenderFns } from "./SvgIconMinus.vue?vue&type=template&id=79ca3b20"
import script from "./SvgIconMinus.vue?vue&type=script&lang=js"
export * from "./SvgIconMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports